<template>
  <sys-data-table
    v-model="produtos_selecionados_computed"
    show-select
    item-key="index"
    :height="altura_janela - 160"
    :item-height="45"
    :headers="cabecalhos"
    :items="lista_produtos"
    :item-class="itemClass"
    @click:row="clicouNaLinha"
  >
    <template #top>
      <div class="d-flex align-center w-full py-2">
        <div class="d-flex align-center pt-2 pb-1">
          <v-icon class="mr-1" :size="22">mdi-format-list-bulleted</v-icon>
          <p class="pa-0 ma-0 font-17 font-weight-medium">Produtos</p>
        </div>

        <v-spacer />

        <v-btn
          color="primary"
          small
          class="mx-2"
          v-if="props.produtos_selecionados.length > 1"
          @click="emit('update:dialog-aplicar-em-massa', true);"
        >
          <v-icon left>mdi-content-save-move-outline</v-icon>
          aplicar em massa
        </v-btn>

        <v-btn
          color="error"
          small
          class="mx-2"
          v-if="props.produtos_selecionados.length > 0"
          @click="removerDaAnalise"
        >
          <v-icon left>mdi-delete</v-icon>
          Remover da analise
        </v-btn>

        <div class="w-350" v-show="produtos_selecionados_computed.length == 0">
          <v-text-field
            v-model="pesquisa"
            hide-details
            dense clearable
            label="Pesquisar"
            append-icon="mdi-magnify"
            v-lazy-input:debounce="2000"
            class="ml-2"
            @input="buscarProdutos"
          />
        </div>
      </div>
    </template>

    <template #item.descricao_produto="{ item }">
      <div class="d-flex align-center">
        <v-icon v-if="item.em_analise_por_lote" class="mr-2">mdi-hexagon-multiple</v-icon>
        <DetalhesProduto
          class="ml-n2"
          :produto="{
            ...produto,
            id_filial: 9999
          }"
        />
        {{ item.descricao_produto }}
      </div>
    </template>
  </sys-data-table>
</template>

<script setup>
import { logout } from "@/helpers";
import { useResize } from "@/helpers/Resize";
import { ref, watch, computed } from "vue";
import Api from "@/api/api";
import DetalhesProduto from "@/components/produto/detalhes/Index.vue";

const emit = defineEmits(['click:produto-linha', 'produtos-selecionados', 'update:dialog-aplicar-em-massa']);

const props = defineProps({
  produtos_selecionados: Array,
  dialog: Boolean,
  produto: Object,
  filtros: Object,
  resetar_dados: Boolean,
  atualizar_produtos_count: Number,
});

const { altura_janela } = useResize();

const lista_produtos = ref([]);

const produtos_selecionados_computed = computed({
  get() {
    return props.produtos_selecionados;
  },
  set(novoValor) {
    emit('update:produtos-selecionados', novoValor);
  }
});

const pesquisa = ref('');

const produto_click_linha = ref(null);

const cabecalhos = [
  { value: 'descricao_grupo', text: 'Grupo' },
  { value: 'idproduto', text: 'Cód. Interno' },
  { value: 'cod_produto', text: 'Cód. Fornecedor' },
  { value: 'descricao_produto', text: 'Descrição do Produto' },
];

watch(() => props.filtros, buscarProdutos);

watch(() => props.atualizar_produtos_count, buscarProdutos);

watch(() => props.resetar_dados, () => {
  lista_produtos.value = [];
  pesquisa.value = '';
});

watch(produto_click_linha, () => {
  emit('click:produto-linha', produto_click_linha.value);
});

function clicouNaLinha(item) {
  produto_click_linha.value = item.row;
}
function buscarProdutos() {
  const grupos = props.filtros.grupos.length ? props.filtros.grupos : props.produto ? [props.produto.id_grupo] : [];

  const parametros = {
    filtros: { ...props.filtros, grupos },
    id_produto: props.produto ? props.produto.id_produto : null,
    pesquisa: pesquisa.value,
  };

  Api
    .post('/compras/produtos/analise-por-lotes/produtos-nao-parametrizados', parametros)
    .then(response => {
      lista_produtos.value = response.data.produtos.map(item => ({ ...item, index: `${item.id_grupo}-${item.idproduto}` }))
      if (lista_produtos.value.length > 0) {
        produto_click_linha.value = lista_produtos.value[0];
      }
    })
    .catch(logout)
}

function removerDaAnalise() {
  const params = produtos_selecionados_computed.value.map(m => ({ id_grupo: m.id_grupo, id_produto: m.idproduto }));
  
  Api
    .post('/compras/produtos/analise-por-lotes/remover-da-analise-por-lote', params)
    .then(() => buscarProdutos())
    .catch(logout)
}


function itemClass (item) {
  if (props.produtos_selecionados.length === 1) {
    return { 'bg-blue-300': item.idproduto === props.produtos_selecionados[0].idproduto && item.id_grupo === props.produtos_selecionados[0].id_grupo }
  }

  if (produto_click_linha.value) {
    return { 'bg-blue-300': item.idproduto === produto_click_linha.value.idproduto && item.id_grupo === produto_click_linha.value.id_grupo }
  }

  return '';
}
</script>
